/* unplugin-vue-components disabled */import script from "./userAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./userAvatar.vue?vue&type=script&setup=true&lang=js"

import "./userAvatar.vue?vue&type=style&index=0&id=7d237d06&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d237d06"]])

export default __exports__